































































































































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { Car } from "@/services/index.defs";
import { ValidationRules } from "_P/validate";
import LanguageControl from "_P/LanguageControl";
import { CarDocumentType, CarDocumentInput } from "@/models/Models";

@Component
export default class CarDocument extends Vue {
    @Prop() car: Car;
    @Ref("carForm") carForm;

    Rules = ValidationRules;

    carDocumentInputs = {
        [CarDocumentType.PTS] : new CarDocumentInput(),
        [CarDocumentType.STS] : new CarDocumentInput(),
        [CarDocumentType.EPTS]: new CarDocumentInput(),
    }

    initFields(){
        const docTypeId = this.car.documentCar.docTypeId;
        const carDocument = this.carDocumentInputs[docTypeId];

        if (!carDocument) return;

        carDocument.seria = this.car.documentCar.seria;
        carDocument.number = this.car.documentCar.number;
    }

    CarDocumentTypes = CarDocumentType;

    seriaHandler(v) {
        const seriaToSave = LanguageControl.EnToRus(v).toUpperCase();
        this.car.documentCar.seria = seriaToSave;
    }

    numberHandler(v) {
        this.car.documentCar.number = v;
    }

    get rulesDocCarSeria() {
        switch (this.car.documentCar.docTypeId) {
        case CarDocumentType.PTS:
            return [this.Rules.requiredSeriesRule, this.Rules.PTSSeries];
        case CarDocumentType.STS:
            return [this.Rules.requiredSeriesRule, this.Rules.STSSeries];
        default:
            return [];
        }
    }

    get rulesDocCarNumber() {
        switch (this.car.documentCar.docTypeId) {
        case CarDocumentType.PTS:
        case CarDocumentType.STS:
            return [this.Rules.requiredNumberRule, this.Rules.STSPTSNumber];
        case CarDocumentType.EPTS:
            return [this.Rules.requiredNumberRule, this.Rules.EPTSFull];
        default:
            return [];
        }
    }

    get currentDocument(): { seria: string, number: string}{
        return this.carDocumentInputs[this.car.documentCar.docTypeId];
    }
    created() {
        this.initFields();
        const doc = this.car.documentCar;
        if (!doc.docTypeId) doc.docTypeId = CarDocumentType.PTS;
        if (!doc.seria && !doc.number) {
            if (!this.car.licensePlate && doc.docTypeId == CarDocumentType.STS)
                doc.docTypeId = CarDocumentType.PTS;
            else if (this.car.licensePlate) doc.docTypeId = CarDocumentType.STS;
        }
        this.$store.direct.commit.insurance.setAutocodeDocumentCar(this.car);
    }

    getTitle(doc: CarDocumentType) {
        switch (doc) {
        case CarDocumentType.PTS:
            return "ПТС";
        case CarDocumentType.EPTS:
            return "ЭПТС";
        case CarDocumentType.STS:
            return "СТС";
        default:
            return "Не определено";
        }
    }

    @Watch("car.documentCar.docTypeId")
    onDocTypeChanged(val: CarDocumentType) {
        if (val == CarDocumentType.EPTS) this.car.documentCar.seria = "";

        const { seria, number } = this.carDocumentInputs[val];
        this.car.documentCar = {...this.car.documentCar, seria, number}

        this.$store.direct.commit.insurance.setAutocodeDocumentCar(this.car);

        this.$nextTick(() => {
            this.carForm?.validate?.();
        });
    }
}
